(() => {
  'use strict';
  const nativeProduct = window.ELEVENINE_NATIVE_PRODUCT || null;
  const routes = window.ELEVENINE_SHOPIFY_ROUTES || {
    add: '/cart/add.js',
    cart: '/cart',
    change: '/cart/change.js',
    checkout: '/checkout'
  };

  const normalize = value => String(value ?? '')
    .trim()
    .toLocaleLowerCase('es-MX')
    .replace('blanco/naranja', 'blanco/rojo');
  const updateBadges = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count],#cartCount').forEach(node => {
        node.textContent = cart.item_count || 0;
        node.classList.toggle('on', cart.item_count > 0);
        node.classList.toggle('is-visible', cart.item_count > 0);
      });
    } catch {}
  };

  const resolveVariant = selections => {
    if (!nativeProduct) return null;
    const optionNames = (nativeProduct.options || []).filter(name => name !== 'Title');
    return (nativeProduct.variants || []).find(variant =>
      optionNames.every((name, index) => normalize(variant.options[index]) === normalize(selections?.[name]))
    ) || (nativeProduct.variants || []).find(variant => variant.available) || nativeProduct.variants?.[0] || null;
  };

  const add = async (product, selections = {}, quantity = 1) => {
    if (!nativeProduct) return { ok: false, message: 'No pudimos cargar este producto de Shopify.' };
    const required = (nativeProduct.options || []).filter(name => name && name !== 'Title');
    const missing = required.filter(name => !selections?.[name]);
    if (missing.length) return { ok: false, message: 'Selecciona: ' + missing.join(', ') };
    const variant = resolveVariant(selections);
    if (!variant) return { ok: false, message: 'Esta combinación no existe en Shopify.' };
    if (!variant.available) return { ok: false, message: 'Esta variante está agotada.' };

    const properties = {};
    Object.entries(selections || {}).forEach(([name, value]) => {
      if (!required.includes(name) && value !== '') properties[name] = String(value);
    });
    const response = await fetch(routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variant.id,
          quantity: Math.max(1, Math.min(99, Number(quantity) || 1)),
          properties
        }]
      })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) return { ok: false, message: result.description || result.message || 'No pudimos agregar el producto.' };
    await updateBadges();
    return { ok: true, result };
  };

  const nativeRoute = href => {
    const value = String(href || '');
    if (value.includes('carrito.html')) return routes.cart;
    if (value.includes('checkout.html')) return routes.checkout;
    if (value.includes('index.html')) return value.replace(/(?:^|\/)index\.html/, '/');
    return value;
  };
  window.ELEVENINE_NATIVE_ROUTE = window.ELEVENINE_NATIVE_ROUTE || nativeRoute;
  window.ELEVENINE_CART = {
    add,
    updateBadges,
    withState: nativeRoute,
    count: () => 0,
    get: () => []
  };
  document.addEventListener('DOMContentLoaded', updateBadges);
  updateBadges();
})();
